export const TOOLTIP_CLASS_NAME = 'onboarding-tour-tooltip';
export const TARGET_POLL_INTERVAL_MS = 150;

const SELECTORS = {
  firstJob: '#onboarding-first-job',
  viewCandidates: '#onboarding-view-candidates',
  firstCandidate: '#onboarding-first-candidate',
  candidateModal: '#onboarding-candidate-modal',
  openDemo: '#onboarding-open-demo',
  billing: '#onboarding-billing',
};

const ROUTES = {
  jobs: '/jobs',
  jobCandidates: (jobId) => `/job/${jobId}/candidates`,
  candidateModal: (jobId, appId) => `/job/${jobId}/candidates/${appId}`,
};

const STEP_IDS = {
  firstJob: 'firstJob',
  viewCandidates: 'viewCandidates',
  firstCandidate: 'firstCandidate',
  candidateModalInfo: 'candidateModalInfo',
  // candidateModalClose: 'candidateModalClose',
  openDemo: 'openDemo',
  billing: 'billing',
};

const routeToJobs = () => ({ path: ROUTES.jobs });

const routeToCandidateList = ({ firstJob }) => (
  firstJob?._id
    ? { path: ROUTES.jobCandidates(firstJob._id) }
    : { fallbackStepId: STEP_IDS.openDemo }
);

const routeToCandidateModal = ({ appData }) => (
  appData
    ? { path: ROUTES.candidateModal(appData.jobId, appData.appId) }
    : { fallbackStepId: STEP_IDS.openDemo }
);

const STEP_CONFIGS = [
  {
    id: STEP_IDS.firstJob,
    target: SELECTORS.firstJob,
    content: 'This is a demo job',
    skipBeacon: true,
    placement: 'bottom',
    getLocation: routeToJobs,
  },
  {
    id: STEP_IDS.viewCandidates,
    target: SELECTORS.viewCandidates,
    content: 'See assessment results here',
    skipBeacon: true,
    placement: 'top',
    getLocation: routeToJobs,
  },
  {
    id: STEP_IDS.firstCandidate,
    target: SELECTORS.firstCandidate,
    content: 'Click to see detailed feedback on candidate',
    skipBeacon: true,
    placement: 'bottom',
    blockTargetInteraction: false,
    getLocation: routeToCandidateList,
  },
  {
    id: STEP_IDS.candidateModalInfo,
    target: SELECTORS.candidateModal,
    content: 'With each assessment you receive AI video interview recording and detailed feedback',
    skipBeacon: true,
    placement: 'left',
    getLocation: routeToCandidateModal,
  },
  // {
  //   id: STEP_IDS.candidateModalClose,
  //   target: SELECTORS.candidateModal,
  //   content: 'Close when ready',
  //   skipBeacon: true,
  //   placement: 'left',
  //   getLocation: routeToCandidateModal,
  // },
  {
    id: STEP_IDS.openDemo,
    target: SELECTORS.openDemo,
    content: 'You can also try the demo interview yourself',
    skipBeacon: true,
    placement: 'top',
    getLocation: routeToJobs,
  },
  {
    id: STEP_IDS.billing,
    target: SELECTORS.billing,
    content: 'Keep an eye on your interview credits here. Each completed candidate interview uses one credit — top up any time to keep hiring without interruption.',
    skipBeacon: true,
    placement: 'right',
    getLocation: routeToJobs,
  },
];

const toJoyrideStep = (stepConfig) => {
  const step = { ...stepConfig };
  delete step.getLocation;
  return step;
};

export const JOYRIDE_STEPS = STEP_CONFIGS.map(toJoyrideStep);
export const FIRST_STEP_INDEX = 0;
export const LAST_STEP_INDEX = STEP_CONFIGS.length - 1;

const getStepIndexById = (stepId) => {
  const index = STEP_CONFIGS.findIndex((step) => step.id === stepId);
  return index === -1 ? FIRST_STEP_INDEX : index;
};

const clampStepIndex = (stepIndex) => {
  const safeStepIndex = Number.isFinite(stepIndex) ? stepIndex : FIRST_STEP_INDEX;
  return Math.max(FIRST_STEP_INDEX, Math.min(safeStepIndex, LAST_STEP_INDEX));
};

export const resolveStepDestination = (requestedStepIndex, context) => {
  let stepIndex = clampStepIndex(requestedStepIndex);
  const visitedStepIds = new Set();

  while (!visitedStepIds.has(STEP_CONFIGS[stepIndex].id)) {
    const step = STEP_CONFIGS[stepIndex];
    visitedStepIds.add(step.id);

    const location = step.getLocation?.(context) ?? routeToJobs();
    if (location.fallbackStepId) {
      stepIndex = getStepIndexById(location.fallbackStepId);
      continue;
    }

    return {
      stepIndex,
      path: location.path,
      selector: location.selector ?? step.target,
    };
  }

  return {
    stepIndex: FIRST_STEP_INDEX,
    path: ROUTES.jobs,
    selector: SELECTORS.firstJob,
  };
};
